import {TYPE} from './type.enum';

export class Pagination {
  page = 1;
  maxRows = 10;
  offset = 'id';
  order: PAGINATION_ORDER = PAGINATION_ORDER.ASCENDENTE;
  keyRow: string;
  keyPage: string;
  keyOrder: string;
  keyOffset: string;
}

export enum PAGINATION_ORDER {
  ASCENDENTE = 'ASC',
  DESCENDENTE = 'DESC'
}

export enum TYPE_DATA {
  TEXT = 'text',
  BOOLEAN = 'boolean',
  DROPDOWN = 'dropdown',
  DATE = 'date',
  NUMBER = 'number',
  URL = 'url',
  TEMPLATE = 'template',
  ACTION = 'action',
}


export class TableLabels {
  key: string;
  background: string;
  type: TYPE = TYPE.DARK;
  title: string;
  value: any;
}

export class ValueDropdown {
  icon = '';
  title = '';
  value = null;
  style_icon = '';
}


export class TableKey {
  keyData: string;
  hidden = false;
  hiddenTitle = false;
  tooltip: any = null;
  onAction = false;
  filter: string;
  isFiltered = true;
  type_data = TYPE_DATA.TEXT;
  title: string;
  sortable = true;
  icon: string;
  template: any;
  type_action: TYPE = TYPE.LIGHT;
  class: string;
  value_DROPDOWN: Array<ValueDropdown> = [];
  labels: TableLabels;
}

export class ResultTable {
  list = [];
  total_resources = 0;
}

export class Table {
  title = '';
  pagination = new Pagination();
  onSelected: boolean = true;
  onSearch: boolean = true;
  isLoading = false;
  isFiltered = false;
  filter: string;
  header: Array<TableKey> = [];
  results: any = new ResultTable();
  queryParam = <any>{};

  get queryParams() {
    let retorno = '';
    const otherKey = [
      {origin: 'maxRows', aux: 'keyRow'},
      {origin: 'page', aux: 'keyPage'},
      {origin: 'order', aux: 'keyOrder'},
      {origin: 'offset', aux: 'keyOffset'}
    ];
    const notLoad = otherKey.map(e => e.aux);

    const arrayQP = [this.pagination, this.queryParam];
    for (const qp of arrayQP) {
      const auxQueryParam = Object.keys(qp) || [];
      if (qp && auxQueryParam.length) {
        const obj = [];
        for (let item of auxQueryParam) {
          if (qp[item] !== null && notLoad.indexOf(item) === -1) {
            const isChange = otherKey.filter(e => e.origin === item)[0];
            obj.push(`${ isChange && qp[isChange.aux] ? qp[isChange.aux]: item }=${qp[item]}`);
          }
        }
        if (retorno) {
          retorno += '&';
        }
        retorno += obj.join('&');
      }
    }
    return retorno;
  }
}
